import type React from "react";

const CalendarPage: React.FC = () => {
	return (
		<div className="space-y-6">
			<h1 className="text-3xl font-bold">カレンダー</h1>
			<div className="bg-white p-6 rounded-lg shadow">
				{/* カレンダーコンポーネントをここに配置 */}
			</div>
		</div>
	);
};

export default CalendarPage;
